const BUILDING_DELETE_DIALOG = 'BUILDING_DELETE_DIALOG';

export default {
  BUILDING_DELETE_DIALOG
};
